/* eslint-disable @typescript-eslint/unbound-method */
export {
  AmplitudeReturn,
  BaseEvent,
  EventOptions,
  BrowserClient,
  AttributionOptions,
  AutocaptureOptions,
  BrowserOptions,
  BrowserConfig,
  IConfig,
  Event,
  IdentifyEvent,
  GroupIdentifyEvent,
  IdentifyOperation,
  SpecialEventType,
  IIdentify,
  IRevenue,
  RevenueProperty,
  ILogger,
  LogLevel,
  Plugin,
  BeforePlugin,
  EnrichmentPlugin,
  DestinationPlugin,
  Result,
  ServerZoneType,
  ServerZone,
  IdentityStorageType,
  Storage,
  TransportType,
  OfflineDisabled,
  Messenger,
  ElementInteractionsOptions,
  ActionType,
  DEFAULT_CSS_SELECTOR_ALLOWLIST,
  DEFAULT_DATA_ATTRIBUTE_PREFIX,
  DEFAULT_ACTION_CLICK_ALLOWLIST,
} from '@amplitude/analytics-core';

export { Campaign, CampaignParser, ClickIdParameters, ReferrerParameters, UTMParameters } from './attribution/campaign';
